import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import BillingCycleMaintenanceCont from "presentation/view/container/BillingCycle/BillingCycleContMain";

CommonEntrypoint(<BillingCycleMaintenanceCont/>)